// src/styles/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        mode: "dark",

        background: {
            default: "#0b1e39", // --background
            paper: "#08162b",   // --azulEscuro
        },

        primary: {
            main: "#1aff7a", // --verdeClaro
            contrastText: "#08162b",
        },

        secondary: {
            main: "#ffffff", // --branco
        },

        text: {
            primary: "#ffffff",
            secondary: "rgba(255,255,255,0.7)",
        },

        divider: "rgba(255, 255, 255, 0.12)", // --linha
    },

    typography: {
        fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",

        h1: { fontWeight: 800 },
        h2: { fontWeight: 700 },
        h3: { fontWeight: 700 },
        h4: { fontWeight: 600 },
        h5: { fontWeight: 600 },
        h6: { fontWeight: 600 },

        button: {
            textTransform: "none",
            fontWeight: 700,
        },
    },

    shape: {
        borderRadius: 12,
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#0b1e39",
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                    border: "1px solid rgba(255,255,255,0.08)",
                },
            },
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    paddingLeft: 24,
                    paddingRight: 24,
                },
            },
        },

        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: "#08162b",
                    borderBottom: "1px solid rgba(255,255,255,0.12)",
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "#08162b",
                    borderRadius: 10,
                },
                notchedOutline: {
                    borderColor: "rgba(255,255,255,0.12)",
                },
            },
        },
    },
});

export default theme;
